import TileHoverVideo from './TileHoverVideo'

export default TileHoverVideo
// eslint-disable-next-line import/export
export * from './TileHoverVideo'
